export default {
  table: {
    id: 'ID',
    password: 'パスワード',
    password_confirm: 'パスワード（確認用）',
    trader: '業者名',
    manager: '担当者名',
    email: 'メールアドレス',
    tel: '電話番号',
    show: '表示',
    vendor_name: '販売者名',
  },
  form: {
    id: 'ID',
    password: 'パスワード',
    password_confirm: 'パスワード（確認用）',

    trader: '業者名',
    manager: '担当者名',
    email: 'メールアドレス',
    tel: '電話番号',
    address: '住所',
    vendor_name: '販売者名',
  },
  label: {
    selector_placeholder: '販売者',
  },
};
